module.exports = __webpack_public_path__ + "media/bootstrap-icons/telephone-x-f772aa7a.svg";